import { Button, Group, Stack } from '@mantine/core';

import { DateTimePickerInput, Select, TextInput } from '@components';
import { SimulateTsdModalProps } from '@features/tsd/TSDList/CustomsSimulator/types';
import { useSimulateTsdWriteOffFormInitializer } from './useSimulateTsdWriteOffFormInitializer';

const WRITE_OFF_NOTIFICATION_STAGE_OPTIONS = [
  { value: '01', label: '01 - Intermediate' },
  { value: '02', label: '02 - Provisional' },
  { value: '03', label: '03 - Final' },
];

const WRITE_OFF_STATUS_OPTIONS = [
  { value: '02', label: '02 - Temporary storage still active' },
  { value: '12', label: '12 - Temporary storage ended' },
];

const WRITE_OFF_STATUS_REASON_OPTIONS = [{ value: '08', label: '08 - Write-off completed at timer expiration' }];

export const SimulateTsdWriteOff: React.FC<SimulateTsdModalProps> = ({ tsd, onHide, onSubmit }) => {
  const {
    form,
    onSubmit: onSubmitForm,
    submitting,
  } = useSimulateTsdWriteOffFormInitializer({
    tsd,
    onHide,
    onSubmit,
  });

  return (
    <form onSubmit={form.onSubmit(onSubmitForm)}>
      <Stack gap="sm" mb="xl">
        <Select
          {...form.getInputProps('notificationStage')}
          label="Notification stage"
          placeholder="Select notification stage"
          data={WRITE_OFF_NOTIFICATION_STAGE_OPTIONS}
          allowDeselect={false}
          onChange={(value) => {
            form.setFieldValue('notificationStage', value as '01' | '02' | '03');

            if (value === '03') {
              form.setFieldValue('status', '12');
              form.setFieldValue('statusReason', '08');
              return;
            }

            form.setFieldValue('status', '02');
          }}
        />

        <DateTimePickerInput {...form.getInputProps('startOfTemporaryStorage')} label="Start of temporary storage" placeholder="Select start date" />

        <DateTimePickerInput {...form.getInputProps('endOfTemporaryStorage')} label="End of temporary storage" placeholder="Select end date" />

        <Select {...form.getInputProps('status')} label="Status" placeholder="Select status" data={WRITE_OFF_STATUS_OPTIONS} allowDeselect={false} />

        <Select
          {...form.getInputProps('statusReason')}
          label="Status reason"
          placeholder="Select status reason"
          data={WRITE_OFF_STATUS_REASON_OPTIONS}
          allowDeselect={false}
        />

        <TextInput {...form.getInputProps('grossMassDeclared')} label="Gross mass declared" placeholder="Gross mass declared" />

        <TextInput {...form.getInputProps('grossMassWrittenOff')} label="Gross mass written-off" placeholder="Gross mass written-off" />

        <TextInput {...form.getInputProps('numberOfPackagesDeclared')} label="Number of packages declared" placeholder="Number of packages declared" />

        <TextInput {...form.getInputProps('numberOfPackagesWrittenOff')} label="Number of packages written-off" placeholder="Number of packages written-off" />
      </Stack>

      <Group justify="center">
        <Button type="button" onClick={onHide} disabled={submitting} size="lg" variant="transparent">
          Cancel
        </Button>

        <Button type="submit" loading={submitting} variant="filled" size="lg" data-pw="simulate-iets045-btn">
          Trigger
        </Button>
      </Group>
    </form>
  );
};
